document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const updateHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const revealItems = document.querySelectorAll('.reveal-up');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const scenes = document.querySelectorAll('[data-depth-scene]');
  scenes.forEach((scene) => {
    const cards = scene.querySelectorAll('[data-depth-card]');
    if (!cards.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    scene.addEventListener('pointermove', (event) => {
      const rect = scene.getBoundingClientRect();
      const nx = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      const ny = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      cards.forEach((card) => {
        const depth = Number(card.dataset.depth || 0.5);
        card.style.setProperty('--mx', `${nx * 15 * depth}px`);
        card.style.setProperty('--my', `${ny * 12 * depth}px`);
        card.style.setProperty('--rx', `${-ny * 2.2 * depth}deg`);
        card.style.setProperty('--ry', `${nx * 3 * depth}deg`);
      });
    });

    scene.addEventListener('pointerleave', () => {
      cards.forEach((card) => {
        card.style.setProperty('--mx', '0px');
        card.style.setProperty('--my', '0px');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  });

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    const updateDepthScroll = () => {
      document.querySelectorAll('[data-depth-card]').forEach((card) => {
        const rect = card.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const viewportCenter = window.innerHeight / 2;
        const normalized = Math.max(-1, Math.min(1, (center - viewportCenter) / window.innerHeight));
        const depth = Number(card.dataset.depth || 0.5);
        card.style.setProperty('--sy', `${normalized * -18 * depth}px`);
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateDepthScroll);
        ticking = true;
      }
    }, { passive: true });
    updateDepthScroll();
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const master = root.querySelector('[data-variant-select]');
    const variantJson = root.querySelector('[data-variant-json]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const saleChip = root.querySelector('[data-sale-chip]');
    const mobilePrice = document.querySelector(`[data-mobile-price="${root.dataset.productRoot}"]`);
    const gallery = root.querySelector('[data-product-gallery]');
    if (!master) return;

    let variants = [];
    if (variantJson) {
      try { variants = JSON.parse(variantJson.textContent); } catch (e) { variants = []; }
    }

    // Best-seller presentation is rendered directly by Liquid for reliable theme-editor updates.

    const setActiveMedia = (mediaId, scrollThumbnail = true) => {
      if (!gallery || !mediaId) return;
      const target = gallery.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"].pdp-main-media`);
      if (!target) return;

      gallery.querySelectorAll('.pdp-main-media[data-media-id]').forEach((media) => {
        const active = media === target;
        media.hidden = !active;
        media.classList.toggle('is-active', active);
      });

      gallery.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
        const active = String(thumb.dataset.mediaId) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && scrollThumbnail) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    };

    gallery?.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => setActiveMedia(thumb.dataset.mediaId, false));
    });

    const renderVariant = () => {
      const option = master.options[master.selectedIndex];
      if (!option) return;
      if (price) price.textContent = option.dataset.price || '';
      if (mobilePrice) mobilePrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (saleChip) saleChip.hidden = !option.dataset.compare;
      if (addButton) {
        const available = option.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableText : addButton.dataset.soldText;
      }
      if (option.dataset.mediaId) setActiveMedia(option.dataset.mediaId);
    };

    root.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-option-group]');
        if (!group) return;
        group.querySelectorAll('[data-option-button]').forEach((b) => {
          const active = b === button;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        const selected = Array.from(root.querySelectorAll('[data-option-group]')).map((g) => {
          const active = g.querySelector('[data-option-button].is-active');
          return active ? active.dataset.optionValue : '';
        });
        const found = variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
        if (found) {
          master.value = String(found.id);
          master.dispatchEvent(new Event('change', { bubbles: true }));

          // Mobile product UX: only visual style changes should bring the
          // updated large product image back into view. Size changes stay in place.
          const changedOptionName = String(group.dataset.optionName || '').trim().toLowerCase();
          const shouldReturnToImage = changedOptionName === 'frame color' || changedOptionName === 'print color';
          if (gallery && shouldReturnToImage && window.matchMedia('(max-width: 760px)').matches) {
            window.setTimeout(() => {
              gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 90);
          }
        }
      });
    });

    master.addEventListener('change', renderVariant);
    renderVariant();
  });

  document.querySelectorAll('[data-scroll-purchase]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector(button.dataset.target || '#product-purchase');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('[data-mobile-buy]').forEach((bar) => {
    const target = document.querySelector(bar.dataset.observeTarget || '#product-purchase');
    if (!target || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => bar.classList.toggle('is-visible', !entry.isIntersecting));
    }, { threshold: 0.16 });
    observer.observe(target);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-reviews]').forEach((section) => {
    const reviewList = section.querySelector('[data-review-list]');
    const pagination = section.querySelector('[data-review-pagination]');

    const reviews = reviewList ? Array.from(reviewList.querySelectorAll('.review-entry')) : [];

    const updateReviewSummary = () => {
      if (!reviews.length) return;
      const ratings = reviews.map((review) => Math.min(5, Math.max(1, Number(review.dataset.rating || 5))));
      const total = ratings.reduce((sum, rating) => sum + rating, 0);
      const average = total / ratings.length;
      const averageText = average.toFixed(1);
      const averageNode = section.querySelector('[data-review-average]');
      const countNode = section.querySelector('[data-review-count]');
      const listCountNode = section.querySelector('[data-review-list-count]');
      const averageStars = section.querySelector('[data-review-average-stars]');
      if (averageNode) averageNode.textContent = averageText;
      const configuredCount = Math.max(0, Number(section.dataset.displayedReviewCount || 0));
      const displayedCount = configuredCount > 0 ? configuredCount : reviews.length;
      if (countNode) countNode.textContent = `${displayedCount} ${displayedCount === 1 ? 'review' : 'reviews'}`;
      if (listCountNode) listCountNode.textContent = `${displayedCount} ${displayedCount === 1 ? 'review' : 'reviews'}`;
      if (averageStars) {
        averageStars.setAttribute('aria-label', `${averageText} out of 5 stars`);
        const fill = averageStars.querySelector('i');
        if (fill) fill.style.width = `${average * 20}%`;
      }
      for (let rating = 1; rating <= 5; rating += 1) {
        const count = ratings.filter((value) => value === rating).length;
        const percent = Math.round((count / reviews.length) * 100);
        const bar = section.querySelector(`[data-review-breakdown-bar="${rating}"]`);
        const label = section.querySelector(`[data-review-breakdown-percent="${rating}"]`);
        if (bar) bar.style.width = `${percent}%`;
        if (label) label.textContent = `${percent}%`;
      }
    };

    updateReviewSummary();

    if (reviewList && pagination) {
      const perPage = Math.max(1, Number(reviewList.dataset.reviewsPerPage || 4));
      const pageCount = Math.ceil(reviews.length / perPage);
      let currentPage = 1;

      const getPaginationItems = (page, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, index) => index + 1);
        if (page <= 4) return [1, 2, 3, 4, 'ellipsis-right', total - 1, total];
        if (page >= total - 3) return [1, 2, 'ellipsis-left', total - 3, total - 2, total - 1, total];
        return [1, 'ellipsis-left', page - 1, page, page + 1, 'ellipsis-right', total];
      };

      const buildPagination = () => {
        pagination.innerHTML = '';
        if (pageCount <= 1) {
          pagination.hidden = true;
          return;
        }
        pagination.hidden = false;

        const prev = document.createElement('button');
        prev.type = 'button';
        prev.textContent = '←';
        prev.className = 'review-pagination__arrow';
        prev.setAttribute('aria-label', 'Previous review page');
        prev.disabled = currentPage === 1;
        prev.addEventListener('click', () => renderPage(currentPage - 1, true));
        pagination.appendChild(prev);

        getPaginationItems(currentPage, pageCount).forEach((item) => {
          if (typeof item === 'string') {
            const dots = document.createElement('span');
            dots.className = 'review-pagination__ellipsis';
            dots.textContent = '…';
            dots.setAttribute('aria-hidden', 'true');
            pagination.appendChild(dots);
            return;
          }
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(item);
          button.className = 'review-pagination__page';
          if (item === currentPage) {
            button.classList.add('is-active');
            button.setAttribute('aria-current', 'page');
          }
          button.setAttribute('aria-label', `Review page ${item}`);
          button.addEventListener('click', () => renderPage(item, true));
          pagination.appendChild(button);
        });

        const next = document.createElement('button');
        next.type = 'button';
        next.textContent = '→';
        next.className = 'review-pagination__arrow';
        next.setAttribute('aria-label', 'Next review page');
        next.disabled = currentPage === pageCount;
        next.addEventListener('click', () => renderPage(currentPage + 1, true));
        pagination.appendChild(next);
      };

      const renderPage = (page, shouldScroll = false) => {
        currentPage = Math.min(Math.max(1, page), Math.max(1, pageCount));
        const start = (currentPage - 1) * perPage;
        const end = start + perPage;
        reviews.forEach((review, index) => { review.hidden = index < start || index >= end; });
        buildPagination();
        if (shouldScroll) {
          const heading = section.querySelector('.review-list__head') || reviewList;
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      renderPage(1, false);
    }

    const dialog = section.querySelector('[data-review-lightbox]');
    const dialogImage = section.querySelector('[data-review-lightbox-image]');
    const closeButton = section.querySelector('[data-review-lightbox-close]');
    if (dialog && dialogImage) {
      const closeDialog = () => {
        if (typeof dialog.close === 'function' && dialog.open) dialog.close();
        else dialog.removeAttribute('open');
        dialogImage.removeAttribute('src');
      };

      section.querySelectorAll('[data-review-image]').forEach((button) => {
        button.addEventListener('click', () => {
          dialogImage.src = button.dataset.reviewImage || '';
          dialogImage.alt = button.dataset.reviewAlt || 'Customer review photo';
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });
      closeButton?.addEventListener('click', closeDialog);
      dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
    }

    const formDialog = section.querySelector('[data-review-form-dialog]');
    const formOpen = section.querySelector('[data-review-form-open]');
    const formClose = section.querySelector('[data-review-form-close]');
    const openForm = () => {
      if (!formDialog) return;
      if (typeof formDialog.showModal === 'function') formDialog.showModal();
      else formDialog.setAttribute('open', '');
    };
    const closeForm = () => {
      if (!formDialog) return;
      if (typeof formDialog.close === 'function' && formDialog.open) formDialog.close();
      else formDialog.removeAttribute('open');
    };
    formOpen?.addEventListener('click', openForm);
    formClose?.addEventListener('click', closeForm);
    formDialog?.addEventListener('click', (event) => { if (event.target === formDialog) closeForm(); });
    if (formDialog?.querySelector('.review-submit-form__success')) openForm();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-customer-photo-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-customer-photo-track]');
    const prev = carousel.querySelector('[data-customer-photo-prev]');
    const next = carousel.querySelector('[data-customer-photo-next]');
    const photoButtons = Array.from(carousel.querySelectorAll('[data-customer-photo-open]'));
    const panel = carousel.closest('.pdp-panel');
    const dialog = panel?.querySelector('[data-customer-photo-lightbox]');
    const dialogImage = dialog?.querySelector('[data-customer-photo-lightbox-image]');
    const close = dialog?.querySelector('[data-customer-photo-close]');
    const lightPrev = dialog?.querySelector('[data-customer-lightbox-prev]');
    const lightNext = dialog?.querySelector('[data-customer-lightbox-next]');

    if (!track) return;

    const getStep = () => {
      const first = track.querySelector('.pdp-customer-photo');
      if (!first) return Math.max(1, track.clientWidth / 3);
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const updateArrows = () => {
      if (prev) prev.disabled = track.scrollLeft <= 3;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
    };

    const scrollByOne = (direction) => {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByOne(-1));
    next?.addEventListener('click', () => scrollByOne(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });

    // Mouse/trackpad dragging on desktop.
    let pointerDragging = false;
    let pointerStartX = 0;
    let pointerStartScroll = 0;
    let pointerMoved = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return;
      pointerDragging = true;
      pointerMoved = false;
      pointerStartX = event.clientX;
      pointerStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(event.pointerId); } catch (e) {}
    });

    track.addEventListener('pointermove', (event) => {
      if (!pointerDragging) return;
      const delta = event.clientX - pointerStartX;
      if (Math.abs(delta) > 5) pointerMoved = true;
      track.scrollLeft = pointerStartScroll - delta;
    });

    const endPointerDrag = (event) => {
      if (!pointerDragging) return;
      pointerDragging = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(event.pointerId); } catch (e) {}
    };

    track.addEventListener('pointerup', endPointerDrag);
    track.addEventListener('pointercancel', endPointerDrag);
    track.addEventListener('pointerleave', (event) => {
      if (pointerDragging) endPointerDrag(event);
    });

    // Explicit touch dragging for iOS / Shopify preview.
    // Only captures the gesture after horizontal motion clearly wins over vertical motion.
    let touchActive = false;
    let touchHorizontal = false;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartScroll = 0;
    let touchMoved = false;

    track.addEventListener('touchstart', (event) => {
      if (!event.touches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      touchActive = true;
      touchHorizontal = false;
      touchMoved = false;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStartScroll = track.scrollLeft;
    }, { passive: true });

    track.addEventListener('touchmove', (event) => {
      if (!touchActive || !event.touches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dx = touch.clientX - touchStartX;
      const dy = touch.clientY - touchStartY;

      if (!touchHorizontal && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        touchHorizontal = true;
      }

      if (touchHorizontal) {
        touchMoved = true;
        event.preventDefault();
        track.scrollLeft = touchStartScroll - dx;
      }
    }, { passive: false });

    track.addEventListener('touchend', () => {
      if (touchHorizontal) {
        const step = getStep();
        if (step > 0) {
          const target = Math.round(track.scrollLeft / step) * step;
          track.scrollTo({ left: target, behavior: 'smooth' });
        }
      }
      touchActive = false;
      touchHorizontal = false;
      setTimeout(() => { touchMoved = false; }, 40);
    }, { passive: true });

    track.addEventListener('touchcancel', () => {
      touchActive = false;
      touchHorizontal = false;
      touchMoved = false;
    }, { passive: true });

    // Photo lightbox.
    let activeIndex = 0;

    const showLightboxImage = (index) => {
      if (!dialog || !dialogImage || !photoButtons.length) return;
      activeIndex = (index + photoButtons.length) % photoButtons.length;
      const button = photoButtons[activeIndex];
      dialogImage.src = button.dataset.customerPhotoSrc || button.querySelector('img')?.src || '';
      dialogImage.alt = button.dataset.customerPhotoAlt || button.querySelector('img')?.alt || 'Customer photo';
      if (lightPrev) lightPrev.hidden = photoButtons.length < 2;
      if (lightNext) lightNext.hidden = photoButtons.length < 2;
    };

    const openDialog = (index) => {
      if (!dialog || !dialogImage) return;
      showLightboxImage(index);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('photo-lightbox-open');
    };

    const closeDialog = () => {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('photo-lightbox-open');
    };

    photoButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        if (pointerMoved || touchMoved) {
          event.preventDefault();
          pointerMoved = false;
          return;
        }
        openDialog(index);
      });
    });

    close?.addEventListener('click', closeDialog);
    lightPrev?.addEventListener('click', () => showLightboxImage(activeIndex - 1));
    lightNext?.addEventListener('click', () => showLightboxImage(activeIndex + 1));

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });

    document.addEventListener('keydown', (event) => {
      if (!dialog?.open) return;
      if (event.key === 'ArrowLeft') showLightboxImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showLightboxImage(activeIndex + 1);
    });

    // Swipe the enlarged photo left/right on mobile too.
    let lightboxTouchX = null;
    dialog?.addEventListener('touchstart', (event) => {
      if (event.touches?.length === 1) lightboxTouchX = event.touches[0].clientX;
    }, { passive: true });

    dialog?.addEventListener('touchend', (event) => {
      if (lightboxTouchX == null || !event.changedTouches?.length) return;
      const dx = event.changedTouches[0].clientX - lightboxTouchX;
      if (Math.abs(dx) > 45) {
        showLightboxImage(activeIndex + (dx < 0 ? 1 : -1));
      }
      lightboxTouchX = null;
    }, { passive: true });

    updateArrows();
  });
});
